<div class="body-wrapper p-3">
    <div class="body-left">
        <div class="header-wrapper " [formGroup]="alertvarservice.ruleForm">
            <div class="header-top pb-6 border-light-bottom">
                <!-- <div class="description">
                    <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.rule_details}}</p>
                    <p class="primary-text content-m">{{alertvarservice.description.auto_closure}}</p>
                </div> -->
                <div class="details" formGroupName="context">
                    <div class="context">
                        <div class="rule-name">
                            <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.rule_name}}</p>
                            <div class="alertDetails">
                                <!-- <p class="content-m primary-text">{{alertvarservice.ruleTitles.auto_rule}}</p> <p class="content-m primary-text bold-text"> {{alertName}}</p> -->
                                  <div class="Titles">
                                    <p class="content-m primary-text auto-rule">{{alertvarservice.ruleTitles.auto_rule}}</p> 
                                    <p class="content-m primary-text bold-text"> {{alertName}}</p>
                                </div>
                                <input class="input-border primary-bg" type="text" [placeholder]="alertvarservice.ruleTitles.description" formControlName="ruleName">
                            </div>
                        </div>
                        <div class="line-2">
                            <div class="time">
                                <div class="timeframe bold-text border-light px-3 pt-3 primary-bg">
                                    <p class=" subtitle light-text m-0 primary-bg px-2 content-s">{{alertvarservice.ruleTitles.time_frame}}</p>
                                    <app-overlay-select fontsize="content-m lighter-text shadow-none" overlaycontainer="border-none" formControlName="timeframe" [data]="alertvarservice.timeframe" >
                                            </app-overlay-select>
                                </div>
                                <div class="stepsize bold-text border-light px-3 pt-3 primary-bg">
                                    <p class="subtitle light-text m-0 primary-bg px-2 content-s">StepSize</p>
                                    <app-overlay-select fontsize="content-m lighter-text shadow-none" overlaycontainer="border-none" formControlName="stepsize" [data]="alertvarservice.stepsize">
                                    </app-overlay-select>
                                </div>
                            </div>
                            <div class="toggles">
                                <div class="activate-rule">
                                    <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.activate_rule}}</p>
                                    <app-toggle-button formControlName="activate"  [leftLabel]="alertvarservice.ruleTitles.no" [rightLabel]="alertvarservice.ruleTitles.yes"></app-toggle-button>
                                </div>
                                <div class="retroactive">
                                    <p class="primary-text bold-text content-l">{{alertvarservice.ruleTitles.run_retroactively}}</p>
                                    <app-toggle-button formControlName="retroactive"  [leftLabel]="alertvarservice.ruleTitles.no" [rightLabel]="alertvarservice.ruleTitles.yes"></app-toggle-button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="alert-danger alert-text content-s pr-5">
                        <div *ngIf="alertvarservice.errorState[1]">{{errstr}}</div>
                    </div>
                </div>
            </div>
        </div>
       <div class="body-left-wrapper">
            <div class="conditions pt-8" [formGroup]="alertvarservice.autoInvestigate">
                <div class="array" formArrayName="conditions">
                    <ng-container *ngFor="let condition of conditions.controls; index as i">
                        <div class="condition-lines" [ngClass]="alertvarservice.process_state ?'disable-click':'enable-click'">
                            <!-- <ng-container *ngIf="i===conditions.length-1">
                                <div class="line-3 border-dark-left border-dark-bottom"></div>
                            </ng-container>
                            <ng-container *ngIf="i!=conditions.length-1">
                            <div class="lines">
                                <div class="line " [ngClass]="i===0?' border-dark-bottom':'border-dark-left border-dark-bottom'"></div>
                                <div class="line-2 border-dark-left "></div>
                            </div>
                            </ng-container> -->
                            <div class="condition-container p-3" [ngClass]="[selectedIndex === i ?'border-blue':'',alertvarservice.process_state ?'disable-click':'enable-click']" [formGroupName]="i" >
                                <ng-container *ngIf="i===0">
                                        <!-- <div class="lines">
                                            <div class="line border-dark-left border-dark-bottom"></div>
                                            <div class="line-2 border-dark-left "></div>
                                        </div> -->
                                        <div class="config " [ngClass]="selectedIndex === i ?'border-blue white-bg':'border-light primary-bg'">
                                            <ng-container>
                                                <img class="icon-s" [ngClass]=" condition.valid ?'':'error-icon'" src="../../../assets/rule/greenTick.svg">
                                                <p class="content-m primary-text">Configuration</p>
                                            </ng-container>
                                        </div>
                                        <div class="clickable px-3 border-light  enable-action" [ngClass]="selectedIndex === i ?'selectable-text white-bg':'primary-text primary-bg'" >
                                            <!-- <p class="content-m">{{alertvarservice.ruleTitles.if}}</p> -->
                                            <p class="content-m">{{alertvarservice.ruleTitles.if}}</p>
                                            <input type="text" formControlName="actions"/>
                                        </div>
                                        <!-- <button class=" add-btn primary-bg p-0" (click)="pushForm(i)"><img class="icon-m enable-action" src="../../../assets/rule/plus.svg" ></button> -->
                                    
                                </ng-container>
                                <!-- <ng-container *ngIf="i>0 && i < conditions.controls.length-1">
                                    
                                    <div class="config" [ngClass]="selectedIndex === i ?'border-blue white-bg':'border-light primary-bg'">
                                        <ng-container>
                                            <img class="icon-s" [ngClass]=" condition.valid ?'':'error-icon'" src="../../../assets/rule/greenTick.svg">
                                            <p class="content-m primary-text">Configuration</p>
                                        </ng-container>
                                    </div>
                                    <div class="clickable  px-3 border-light  enable-action" [ngClass]="selectedIndex === i ?'selectable-text white-bg':'primary-text primary-bg'" (click)="conditionClick(i)"><p class="content-l">{{alertvarservice.ruleTitles.else_if}}</p>
                                        <input type="text" formControlName="actions"/>
                                    </div>
                                    <button class="add-btn primary-bg p-0" (click)="pushForm(i)"><img class="icon-m enable-action" src="../../../assets/rule/plus.svg" ></button>
                                    <button class="remove-btn p-0" (click)="removeForm(i)"><img class="icon-m enable-action" src="../../../assets/rule/delete.svg" ></button>
                                </ng-container>
                                <ng-container *ngIf="i===conditions.controls.length-1">
                                   
                                    <div class="config" [ngClass]="selectedIndex === i ?'border-blue white-bg':'border-light primary-bg'">
                                        <ng-container>
                                            <img class="icon-s" [ngClass]=" condition.valid ?'':'error-icon'" src="../../../assets/rule/greenTick.svg">
                                            <p class="content-m primary-text">Configuration</p>
                                        </ng-container>
                                    </div>
                                    <div class="clickable px-3 border-light  enable-action" [ngClass]="selectedIndex === i ?'selectable-text white-bg':'primary-text primary-bg'" (click)="conditionClick(i)"><p class="content-l">{{alertvarservice.ruleTitles.else}}</p>
                                        <input type="text" formControlName="actions"/>
                                    </div>
                                </ng-container> -->
                                
                            </div>
                        </div>
                    </ng-container>
                    <!-- <button class="submit" (click)="checkAction()">Check</button> -->
                </div>
            </div>
       </div>
    </div>
    <div class="body-right pl-6 border-light-left" [formGroup]="form">
        <app-closure-action formControlName="closureAction"></app-closure-action>
    </div>
    <div></div>
    <div class="footer p-3">
        <div class="buttons pr-5">
            <button class="submit" (click)="submitClicked()">{{alertvarservice.ruleTitles.save}}</button>
            <button class="cancel" (click)="cancelClick()">{{alertvarservice.ruleTitles.cancel}}</button>
        </div>
    </div>
</div>

